
<f-dialog
    v-if          = "data"
    v-model       = "show"
    :width        = "1200"
    :show-header  = "true"
    :show-save    = "true"
    :title        = "title"
    store-label   = "Drucken"
    @store        = "onPrint"
    @cancel       = "onCancel"
>
    <template v-slot:content>
        <v-form ref="form">
            <v-row dense class="mt-0">
                <v-col class="no-frame pr-2 col-4">
                    <f-title
                        title="Grundstück"
                    />
                    <div class="box-first-row">
                        <v-row dense>
                            <v-col class="no-frame">
                                <f-read-only-field
                                    label  = "VE2"
                                    :value = "data.site.ve2"
                                    style="margin-top: -1px"
                                />
                            </v-col>
                        </v-row>
                        <v-row dense>
                            <v-col class="no-frame">
                                <f-read-only-field
                                    label  = "Strasse"
                                    :value = "data.site.street"
                                    style="margin-top: -1px"
                                />
                            </v-col>
                        </v-row>
                        <v-row dense class="mb-4">
                            <v-col class="no-frame col-4 pr-2">
                                <f-read-only-field
                                    label  = "PLZ"
                                    :value = "data.site.zip"
                                    dense
                                />
                            </v-col>
                            <v-col class="no-frame col-8 pl-2">
                                <f-read-only-field
                                    label  = "Ort"
                                    :value = "data.site.city"
                                    dense
                                />
                            </v-col>
                        </v-row>
                        <v-row dense class="mb-4">
                            <v-col class="no-frame col-12">
                                <f-read-only-field
                                    label  = "Anlagen"
                                    :value = "data.site.units"
                                    dense
                                />
                            </v-col>
                        </v-row>
                    </div>

                    <!-- beneficiary -->
                    <f-title
                        title="Leistungsempfänger"
                        class="mt-4"
                    />
                    <div class="box" >
                        <v-row dense>
                            <v-col class="no-frame">
                                <f-read-only-field
                                    label  = "Name"
                                    :value = "data.beneficiary.name"
                                    style="margin-top: -1px"
                                />
                            </v-col>
                        </v-row>
                        <v-row dense>
                            <v-col class="no-frame">
                                <f-read-only-field
                                    label  = "c/o"
                                    :value = "data.beneficiary.nameAdd"
                                    style="margin-top: -1px"
                                />
                            </v-col>
                        </v-row>
                        <v-row dense>
                            <v-col class="no-frame">
                                <f-read-only-field
                                    label  = "Strasse"
                                    :value = "data.beneficiary.street"
                                    style="margin-top: -1px"
                                />
                            </v-col>
                        </v-row>
                        <v-row dense>
                            <v-col class="no-frame col-4 pr-2">
                                <f-read-only-field
                                    label  = "PLZ"
                                    :value = "data.beneficiary.zip"
                                    style="margin-top: -1px"
                                />
                            </v-col>
                            <v-col class="no-frame col-8 pl-2">
                                <f-read-only-field
                                    label  = "Ort"
                                    :value = "data.beneficiary.city"
                                    style="margin-top: -1px"
                                />
                            </v-col>
                        </v-row>
                    </div>
                    <!-- beneficiary -->
                </v-col>

                <v-col class="no-frame col-4 pr-2">
                    <!-- Terms and deadlines -->
                    <f-title
                        title="Fristen und Termine"
                        class="mt-0"
                    />
                    <div class="box-first-row">
                        <v-row dense>
                            <v-col class="no-frame pr-2">
                                <f-date-picker
                                    label         = "repair.bid.date"
                                    v-model       = "data.bid.date"
                                    :rules        = "[ requiredRule ]"
                                    :hide-details = "true"
                                />
                            </v-col>
                            <v-col class="no-frame pl-2">
                                <f-date-picker
                                    label         = "repair.bid.deadlineDate"
                                    v-model       = "data.bid.deadline"
                                    :hide-details = "true"
                                />
                            </v-col>
                        </v-row>
                        <v-row class="no-frame mb-4 mt-6">
                            <v-col class="no-frame pr-2">
                                <f-date-picker
                                    label         = "repair.bid.execute.begin"
                                    v-model       = "data.date1"
                                    :hide-details = "true"
                                />
                            </v-col>
                            <v-col class="no-frame pl-2">
                                <f-date-picker
                                    label         = "repair.bid.execute.end"
                                    v-model       = "data.date2"
                                    :hide-details = "true"
                                />
                            </v-col>
                        </v-row>
                        <v-row class="no-frame mb-4 mt-6">
                            <v-col class="no-frame pr-2">
                                <f-date-picker
                                    label         = "repair.bid.orderDate"
                                    v-model       = "data.bid.orderDate"
                                    :hide-details = "true"
                                />
                            </v-col>
                            <v-col class="no-frame pl-2">
                            </v-col>
                        </v-row>
                    </div>
                    <!-- Terms and deadlines -->

                    <!-- invoice recipient -->
                    <f-title
                        title="Rechnungsempfänger"
                        class="mt-4"
                    />
                    <div class="box" >
                        <v-row dense>
                            <v-col class="no-frame">
                                <f-read-only-field
                                    label  = "Name"
                                    :value = "data.invoice.name"
                                    style="margin-top: -1px"
                                />
                            </v-col>
                        </v-row>
                        <v-row dense>
                            <v-col class="no-frame">
                                <f-read-only-field
                                    label  = "c/o"
                                    :value = "data.invoice.nameAdd"
                                    style="margin-top: -1px"
                                />
                            </v-col>
                        </v-row>
                        <v-row dense>
                            <v-col class="no-frame">
                                <f-read-only-field
                                    label  = "Strasse"
                                    :value = "data.invoice.street"
                                    style="margin-top: -1px"
                                />
                            </v-col>
                        </v-row>
                        <v-row dense>
                            <v-col class="no-frame col-4 pr-2">
                                <f-read-only-field
                                    label  = "PLZ"
                                    :value = "data.invoice.zip"
                                    style="margin-top: -1px"
                                />
                            </v-col>
                            <v-col class="no-frame col-8 pl-2">
                                <f-read-only-field
                                    label  = "Ort"
                                    :value = "data.invoice.city"
                                    style="margin-top: -1px"
                                />
                            </v-col>
                        </v-row>
                    </div>
                    <!-- invoice recipient  -->
                </v-col>

                <v-col class="no-frame col-4">

                    <!-- recommended bid -->
                    <f-title
                        title="Empfohlenes Angebot"
                        class="mt-0"
                    />
                    <div class="box-first-row">
                        <v-row dense>
                            <v-col class="no-frame col-6 pr-2">
                                <f-currency-field
                                    v-model   = "data.bid.recommended"
                                    :readonly = "true"
                                    label="Auftragssumme"
                                    class="money"
                                    :hide-details="true"
                                />
                            </v-col>
                            <v-col class="no-frame col-6 pr-2">
                                <f-currency-field
                                    v-if      = "data.bid.amount"
                                    v-model   = "data.bid.amount"
                                    :readonly = "true"
                                    class     = "money"
                                    label     = "Angebotspreis (Ursprung)"
                                    hide-details="true"
                                />
                            </v-col>
                        </v-row>
                        <v-row dense class="mt-4">
                            <v-col class="no-frame col-6 pr-2">
                                <f-currency-field
                                    v-model   = "data.bid.vatAmount"
                                    :readonly = "true"
                                    label="MwSt."
                                    class="money"
                                    :hide-details="true"
                                />
                            </v-col>
                            <v-col class="no-frame col-6 pr-2">
                            </v-col>
                        </v-row>
                        <v-row dense class="mt-4">
                            <v-col class="no-frame col-6 pr-2">
                                <f-currency-field
                                    v-model   = "data.bid.amountGross"
                                    :readonly = "true"
                                    label="Brutto."
                                    class="money"
                                    :hide-details="true"
                                />
                            </v-col>
                            <v-col class="no-frame col-6 pr-2">
                            </v-col>
                        </v-row>
                        <v-row dense>
                            <v-col class="no-frame col-12">
                                <div class="lm-border pa-2 mt-4" style="height: 80px; overflow-y: auto" v-html="toHtml(data.bid.measure)">
                                </div>
                            </v-col>
                        </v-row>
                    </div>
                    <!-- recommended bid -->
                    <!-- contractor -->
                    <f-title
                        title="Auftragnehmer"
                        class="mt-4"
                    />
                    <div class="box">
                        <v-row dense>
                            <v-col class="no-frame">
                                <f-read-only-field
                                    label  = "Name"
                                    :value = "data.contractor.name"
                                    style="margin-top: -1px"
                                />
                            </v-col>
                        </v-row>
                        <v-row dense>
                            <v-col class="no-frame">
                                <f-read-only-field
                                    label  = "Strasse"
                                    :value = "data.contractor.street"
                                    style="margin-top: -1px"
                                />
                            </v-col>
                        </v-row>
                        <v-row dense>
                            <v-col class="no-frame col-4 pr-2">
                                <f-read-only-field
                                    label  = "PLZ"
                                    :value = "data.contractor.zip"
                                    style="margin-top: -1px"
                                />
                            </v-col>
                            <v-col class="no-frame col-8 pl-2">
                                <f-read-only-field
                                    label  = "Ort"
                                    :value = "data.contractor.city"
                                    style="margin-top: -1px"
                                />
                            </v-col>
                        </v-row>
                    </div>
                    <!-- contractor -->
                </v-col>
            </v-row>
        </v-form>
    </template>
</f-dialog>
